import { render, staticRenderFns } from "./Btables.vue?vue&type=template&id=4fdb0db1&"
import script from "./Btables.vue?vue&type=script&lang=js&"
export * from "./Btables.vue?vue&type=script&lang=js&"
import style0 from "./Btables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports